import { EEbiFormCategory, EEbiFormOffice, IEbiFormDefinition } from "modules/ebiForms/typings";

/**
 * H5. Rejestracja jako osoba bezrobotna lub poszukująca pracy (zasiłek przyznawany z urzędu na podstawie dokumentów
 * złożonych przy rejestracji) — art. 55 i 59–63 ustawy z 20.03.2025 r. o rynku pracy i służbach zatrudnienia. Jedynym
 * kanałem e-rejestracji jest formularz KRB w praca.gov.pl (katalog: „nie dublować rejestracji”) — EBI tylko odsyła.
 * Adres usługi z katalogu (sprawdzony 2026-10-21, aplikacja wymaga logowania).
 */
const H5: IEbiFormDefinition = {
  code: "H5",
  version: 1,
  title: "Rejestracja jako osoba bezrobotna lub poszukująca pracy",
  category: EEbiFormCategory.Labour,
  office: EEbiFormOffice.CountyUnit,
  description: "Rejestracja w powiatowym urzędzie pracy jako bezrobotny lub poszukujący pracy (także zasiłek dla bezrobotnych) — elektronicznie w praca.gov.pl.",
  keywords: ["bezrobotny", "rejestracja", "urząd pracy", "PUP", "zasiłek dla bezrobotnych", "poszukujący pracy", "KRB"],
  organ: "Starosta — Powiatowy Urząd Pracy właściwy według miejsca zamieszkania",
  legalBasis: "art. 55 i art. 59–63 ustawy z dnia 20 marca 2025 r. o rynku pracy i służbach zatrudnienia",
  fee: "Bez opłaty.",
  external: {
    service: "praca.gov.pl",
    url: "https://www.praca.gov.pl/eurzad/index.eup",
    text: "Zarejestrujesz się osobiście w powiatowym urzędzie pracy właściwym dla miejsca zamieszkania albo elektronicznie w praca.gov.pl — formularz „Zgłoszenie do rejestracji jako osoba bezrobotna lub poszukująca pracy” (KRB), podpisany profilem zaufanym lub podpisem kwalifikowanym. Przygotuj świadectwa ukończenia szkoły i dyplomy, dokumenty potwierdzające kwalifikacje, świadectwa pracy i inne dokumenty potrzebne do ustalenia prawa do zasiłku, a jeśli dotyczy — orzeczenie o niepełnosprawności. Zasiłek urząd przyznaje z urzędu na podstawie dokumentów złożonych przy rejestracji.",
  },
  sections: [],
  attachments: [],
};

export default H5;
